export const useMockApi = (window as any)?.bootstrap?.useMockApi;

const apiEnvironment = (window as any)?.bootstrap?.apiEnvironment;

const dev2: ApiEndpoints = {
	ecdPlusPrc: 'https://enterprise-apitest.cpg.org/d2/common-access-api/1.0/ecdPlus/',
	mailPrc: '/api/v1/mail/',
};

const test1: ApiEndpoints = {
	ecdPlusPrc: 'https://enterprise-apitest.cpg.org/t1/common-access-api/1.0/ecdPlus/',
	mailPrc: '/api/v1/mail/',
};

const test2: ApiEndpoints = {
	ecdPlusPrc: 'https://enterprise-apitest.cpg.org/t2/common-access-api/1.0/ecdPlus/',
	mailPrc: '/api/v1/mail/',
};

const sandbox: ApiEndpoints = {
	ecdPlusPrc: 'https://enterprise-apitest.cpg.org/sbox/common-access-api/1.0/ecdPlus/',
	mailPrc: '/api/v1/mail/',
};

const prod: ApiEndpoints = {
	ecdPlusPrc: 'https://ea-api.cpg.org/common-access-api/1.0/ecdPlus/',
	mailPrc: '/api/v1/mail/',
};

interface ApiEndpoints {
	ecdPlusPrc: string;	
	mailPrc: string;
}

const apiEndPoints = {
	dev2,
	test1,
	test2,
	sandbox,
	prod,
};

const defaultApi = 'dev2';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ApiEndpoint = apiEndPoints[apiEnvironment || defaultApi] as ApiEndpoints;